import { render } from "./PartnersTable.vue?vue&type=template&id=9f8f3b1e&scoped=true"
import script from "./PartnersTable.vue?vue&type=script&lang=js"
export * from "./PartnersTable.vue?vue&type=script&lang=js"

import "./PartnersTable.vue?vue&type=style&index=0&id=9f8f3b1e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8f3b1e"]])

export default __exports__